function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import vent from 'elements/vent';
import $ from 'jquery';
export var pcsFormTimeline = new ( /*#__PURE__*/function () {
  function PcsFormTimeline() {
    var _this = this;
    _classCallCheck(this, PcsFormTimeline);
    vent.on('APP:READY', function (_) {
      _this.init();
    });
  }
  _createClass(PcsFormTimeline, [{
    key: "init",
    value: function init() {
      $(document).on('click', '.pcs-form-timeline__item', this.onClickTimelineItem.bind(this));
    }
  }, {
    key: "onClickTimelineItem",
    value: function onClickTimelineItem(e) {
      e.preventDefault();
      $('#form-show-item').find('[name="item"]').val($(e.target).attr('data-name'));
      $('#form-show-item').submit();
    }
  }]);
  return PcsFormTimeline;
}())();